module.exports = __webpack_public_path__ + "img/kt.dbbf8afe.svg";